import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "./../../../hooks/useSnackbar";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField,
  Checkbox,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Collapse
} from "@mui/material";

import Box from "@mui/material/Box";

import FormControl from "@mui/material/FormControl";

import { useTheme } from "@mui/material/styles";

import RefreshIcon from "@mui/icons-material/Refresh";
import UndoIcon from "@mui/icons-material/Undo";
import SaveIcon from "@mui/icons-material/Save";
import LooksIcon from "@mui/icons-material/Looks";

import ContainerLoading from "../../../components/Loading/ContainerLoading";
import MyNumberInput from "../../Admin/components/Shared/myNumberInput";

import { formatDate } from "../../../utils/misc";

import UpdateLogRow from "./ErrorLogs/ErrorLogRow";

import EditDialog from "./Configuration/EditDialog";

import { KEY_NAME_REGEX } from "../../../constants";

import RefresherContext from "../../../contexts/Shared/RefresherProvider/RefresherContext";
import HttpContext from "../../../contexts/HTTP/HttpContext";

import moment from "moment";

import { WORKFLOW_MODES } from "../../../constants";

function ServerSettings() {
  const theme = useTheme();
  const { get, post } = useContext(HttpContext);
  const { triggerUpdate } = useContext(RefresherContext);

  const [loading, setLoading] = useState(true);

  const [editDialogIsOpened, setEditDialogIsOpened] = useState(false);
  const [editDialogData, setEditDialogData] = useState(null);
  const [editDialogIndex, setEditDialogIndex] = useState(null);

  const [serverSetting, setServerSetting] = useState(null);

  const [hasChange, setHasChange] = useState(false);

  const [themeDialogOpen, setThemeDialogOpen] = useState(false);

  const { openSnackbar } = useSnackbar();

  const loadData = async () => {
    setLoading(true);

    //Load data
    const res2 = await get("/kiosk/getServerSetting/ConsignAction");

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load server settings",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const data = _.get(res2, "data");

      await setServerSetting(data);
    }

    setHasChange(false);
    setLoading(false);
  };

  const handleUpdateSettings = async settings => {
    await setServerSetting({ ...serverSetting, settings: settings });
    await setHasChange(true);
  };

  const handleUpdateTheme = async newthemes => {
    await setServerSetting({
      ...serverSetting,
      theme: { ...serverSetting.theme, ...newthemes }
    });
    await setHasChange(true);
  };

  const handleNumericalUpdateSettings = async settings => {
    await setServerSetting({ ...serverSetting, settings: settings });
    await setHasChange(true);
  };

  const saveSettings = async settings => {
    const res2 = await post(
      "/kiosk/serverSetting/ConsignAction",
      serverSetting
    );
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      //SInce format can change, just reload from server
      openSnackbar({
        open: true,
        message: "Successfully updated!",
        variant: "alert",
        alert: {
          color: "success"
        },
        close: false
      });
      await loadData();

      //console.log("[DEBUG] IssueSMU triggerUpdate()", triggerUpdate);
      triggerUpdate(); //Updates Navigation SideMenu

      return subscriptionData;
    }
  };

  const isPositiveOrZeroNumber = str => {
    // Remove leading/trailing whitespace
    str = str.trim();

    // Check if it's a valid number and positive or zero
    const num = Number(str);
    return !isNaN(num) && num >= 0 && str.length > 0;
  };

  const EditSettings = index => {
    console.log("Configuration.EditSettings() index", index);
    setEditDialogIndex(index);
    setEditDialogData(setServerSetting);
    setEditDialogIsOpened(true);
  };

  const MyAccordionBody = React.memo(({ children, show }) => {
    return (
      <div
        class="ItemBody"
        style={{
          //backgroundColor: "#ffffff",
          //border: "1px solid #e0e0e0",
          //padding: "0 16px",
          maxHeight: show ? "100vh" : "0vh", // Use a large enough max-height
          overflow: "hidden",
          transition: "max-height 0.3s ease-in-out"
        }}
      >
        <div
          style={{
            margin: "12px 0"
          }}
        >
          {/* BODY CONTENT */}
          <Grid container spacing={2}>
            {children}
          </Grid>
        </div>
      </div>
    );
  });

  const loadDetails = async id => {};

  useEffect(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      {/* ///////////////// */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h4">Server Settings</Typography>
          {/* <Typography>View and edit your server settings</Typography> */}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: theme.spacing(2),
          position: "sticky",
          top: "0px",
          height: "50px",
          zIndex: 20,
          backgroundColor: "rgb(245, 245, 245)"
        }}
      >
        <div
          style={{
            position: "absolute",
            right: 0,
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1),
            top: "0px",
            margin: "6px",
            backgroundColor: "rgb(245, 245, 245)"
          }}
        >
          {hasChange ? (
            <div
              style={{
                marginTop: "6px",
                fontStyle: "italic",
                color: "darkorange"
              }}
            >
              Changes pending
            </div>
          ) : (
            <></>
          )}
          <Button
            variant="outline"
            onClick={() => loadData()}
            disabled={loading}
          >
            <UndoIcon style={{ marginRight: theme.spacing(1) }} />
            Revert
          </Button>
          <Button
            variant="contained"
            onClick={() => saveSettings()}
            disabled={loading}
          >
            <SaveIcon style={{ marginRight: theme.spacing(1) }} />
            Save
          </Button>
        </div>
      </div>
      {/* / Sticky Header */}
      <Divider
        style={{
          marginBottom: theme.spacing(2),
          marginTop: theme.spacing(2)
        }}
      />
      <ContainerLoading show={loading} />
      <TableContainer>
        {serverSetting && (
          <Table
            style={{
              marginTop: theme.spacing(2),
              display: loading ? "none" : null
            }}
          >
            <TableHead></TableHead>

            <center>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      pb: 1,
                      mb: 1
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="primary"
                      sx={{ fontWeight: 600 }}
                    >
                      Kiosk Settings
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  App Name
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtAppName"
                    value={serverSetting.theme.appName}
                    onChange={event => {
                      handleUpdateTheme({ appName: event.target.value });
                      document.title = event.target.value;
                    }}
                    variant="outlined"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Settings Access Code
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtSettingsAccessCode"
                    value={serverSetting.settings.settingsAccessCode}
                    onChange={event => {
                      handleUpdateSettings({
                        ...serverSetting.settings,
                        settingsAccessCode: event.target.value
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Bi-Lingual
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <Switch
                    checked={serverSetting.theme.bilingual}
                    onChange={event => {
                      handleUpdateTheme({ bilingual: event.target.checked });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Quick Start
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <Switch
                    checked={serverSetting.theme.quickStart}
                    onChange={event => {
                      handleUpdateTheme({ quickStart: event.target.checked });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Enable Charities
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <Switch
                    checked={serverSetting.theme.enableCharities}
                    onChange={event => {
                      handleUpdateTheme({
                        enableCharities: event.target.checked
                      });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Show Partner Logo
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <Switch
                    checked={serverSetting.theme.showPartnerLogo}
                    onChange={event => {
                      handleUpdateTheme({
                        showPartnerLogo: event.target.checked
                      });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Days to Count
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtDaysToCount"
                    value={serverSetting.theme.daysToCount}
                    onChange={event => {
                      handleUpdateTheme({ daysToCount: event.target.value });
                    }}
                    variant="outlined"
                    fullWidth
                    type="number"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Phone Format
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtPhoneFormat"
                    value={serverSetting.theme.phoneFormat}
                    onChange={event => {
                      handleUpdateTheme({ phoneFormat: event.target.value });
                    }}
                    variant="outlined"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Enable Web Clients Globally
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <Switch
                    checked={serverSetting.settings.enableWeb}
                    onChange={async event => {
                      console.log("Toggle onChange event", event);
                      handleUpdateSettings({
                        ...serverSetting.settings,
                        enableWeb: event.target.checked
                      });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Max Labels Allowed
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtmaxlabelsallowed"
                    variant="outlined"
                    fullWidth
                    value={serverSetting.settings.maxLabelsAllowed}
                    onChange={async event => {
                      if (isPositiveOrZeroNumber(event.target.value)) {
                        handleUpdateSettings({
                          ...serverSetting.settings,
                          maxLabelsAllowed: event.target.value
                        });
                      }
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  App Hostname
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtcaapphostname"
                    variant="outlined"
                    fullWidth
                    value={serverSetting.settings.consignactionappHostname}
                    onChange={async event => {
                      handleUpdateSettings({
                        ...serverSetting.settings,
                        consignactionappHostname: event.target.value
                      });
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Default New Kiosk Workflow
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <FormControl sx={{ m: 1, minWidth: 230 }}>
                    <Select
                      labelId="batch-update-open-select-label"
                      id="batch-update-open-select"
                      fullWidth
                      //label="Workflow Mode"
                      value={serverSetting.settings.defaultNewKioskWorkflow}
                      onChange={async event => {
                        handleUpdateSettings({
                          ...serverSetting.settings,
                          defaultNewKioskWorkflow: event.target.value
                        });
                      }}
                      sx={{
                        backgroundColor: "white"
                      }}
                    >
                      <MenuItem value={WORKFLOW_MODES.BAGS_AND_LABELS}>
                        Bag and Labels
                      </MenuItem>
                      <MenuItem value={WORKFLOW_MODES.BAG_ONLY}>
                        Bags Only
                      </MenuItem>
                      <MenuItem value={WORKFLOW_MODES.BAG_ONLY_WITH_AUTH}>
                        Bags Only With Authenication
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Authentication Threshold
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <TextField
                    id="txtmaxlabelsallowed"
                    variant="outlined"
                    fullWidth
                    value={serverSetting.settings.authenticationThreshold}
                    onChange={async event => {
                      if (isPositiveOrZeroNumber(event.target.value)) {
                        handleUpdateSettings({
                          ...serverSetting.settings,
                          authenticationThreshold: event.target.value
                        });
                      }
                    }}
                    sx={{
                      backgroundColor: "white"
                    }}
                  />
                  {/* <FormControl sx={{ m: 1, minWidth: 230 }}>
                    <TextField
                      id="txtmaxlabelsallowed"
                      variant="outlined"
                      fullWidth
                      value={serverSetting.settings.authenticationThreshold}
                      onChange={async event => {
                        if (isPositiveOrZeroNumber(event.target.value)) {
                          handleUpdateSettings({
                            ...serverSetting.settings,
                            authenticationThreshold: event.target.value
                          });
                        }
                      }}
                      sx={{
                        backgroundColor: "white"
                      }}
                    />
                  </FormControl> */}
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      pb: 1,
                      mb: 1
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="primary"
                      sx={{ fontWeight: 600 }}
                    >
                      Log Settings
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} style={{ alignContent: "center" }}>
                  Enable Error Logs
                </Grid>
                <Grid item xs={6} style={{ alignContent: "center" }}>
                  <FormControl sx={{ m: 1, minWidth: 230 }}>
                    <Switch
                      checked={serverSetting.settings.syncLoggingEnabled}
                      onChange={async event => {
                        console.log("Toggle onChange event", event);
                        handleUpdateSettings({
                          ...serverSetting.settings,
                          syncLoggingEnabled: event.target.checked
                        });
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </FormControl>
                </Grid>
                {/* Attempt at using animation, still not working */}
                {/* 
                <Grid item xs={12} style={{ display: "block" }}>
                  <MyAccordionBody
                    show={serverSetting.settings.syncLoggingEnabled}
                  >
                    <>
                      <Grid item xs={6} style={{ alignContent: "center" }}>
                        Enable Inbound Payload Capture
                      </Grid>
                      <Grid item xs={6} style={{ alignContent: "center" }}>
                        <FormControl sx={{ m: 1, minWidth: 230 }}>
                          <Switch
                            checked={
                              serverSetting.settings.syncLoggingLogInboundData
                            }
                            onChange={async event => {
                              console.log("Toggle onChange event", event);
                              handleUpdateSettings({
                                ...serverSetting.settings,
                                syncLoggingLogInboundData: event.target.checked
                              });
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} style={{ alignContent: "center" }}>
                        Enable Automatic Log Cleanup
                      </Grid>
                      <Grid item xs={6} style={{ alignContent: "center" }}>
                        <FormControl sx={{ m: 1, minWidth: 230 }}>
                          <Switch
                            checked={
                              serverSetting.settings.syncLoggingCullEnabled
                            }
                            onChange={async event => {
                              console.log("Toggle onChange event", event);
                              handleUpdateSettings({
                                ...serverSetting.settings,
                                syncLoggingCullEnabled: event.target.checked
                              });
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </FormControl>
                      </Grid>
                    </>
                  </MyAccordionBody>
                </Grid> */}

                {serverSetting.settings.syncLoggingEnabled ? (
                  <>
                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      Enable Inbound Payload Capture
                    </Grid>
                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      <FormControl sx={{ m: 1, minWidth: 230 }}>
                        <Switch
                          checked={
                            serverSetting.settings.syncLoggingLogInboundData
                          }
                          onChange={async event => {
                            console.log("Toggle onChange event", event);
                            handleUpdateSettings({
                              ...serverSetting.settings,
                              syncLoggingLogInboundData: event.target.checked
                            });
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      Enable Automatic Log Cleanup
                    </Grid>
                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      <FormControl sx={{ m: 1, minWidth: 230 }}>
                        <Switch
                          checked={
                            serverSetting.settings.syncLoggingCullEnabled
                          }
                          onChange={async event => {
                            console.log("Toggle onChange event", event);
                            handleUpdateSettings({
                              ...serverSetting.settings,
                              syncLoggingCullEnabled: event.target.checked
                            });
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </FormControl>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

                {!(
                  serverSetting.settings.syncLoggingEnabled &&
                  serverSetting.settings.syncLoggingCullEnabled
                ) ? (
                  <></>
                ) : (
                  <>
                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      Log Cleanup Threshold (Entries)
                    </Grid>
                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      <FormControl sx={{ m: 1, minWidth: 230 }}>
                        <MyNumberInput
                          id="outlined-number"
                          value={serverSetting.settings.syncLoggingCullTrigger}
                          onBlur={async val => {
                            await handleUpdateSettings({
                              ...serverSetting.settings,
                              syncLoggingCullTrigger: val
                            });
                          }}
                          checkValueHandler={value => {
                            if (value > 39) {
                              return true;
                            }
                            openSnackbar({
                              open: true,
                              message: "Value must be at least 40",
                              variant: "alert",
                              alert: {
                                color: "error"
                              },
                              close: false
                            });
                            return false;
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      Logs to Retain After Cleanup (Entries)
                    </Grid>
                    <Grid item xs={6} style={{ alignContent: "center" }}>
                      <FormControl sx={{ m: 1, minWidth: 230 }}>
                        <MyNumberInput
                          id="outlined-number"
                          value={
                            serverSetting.settings.syncLoggingCullKeepTotal
                          }
                          onBlur={async val => {
                            await handleUpdateSettings({
                              ...serverSetting.settings,
                              syncLoggingCullKeepTotal: val
                            });
                          }}
                          checkValueHandler={value => {
                            if (
                              value > 39 &&
                              value <
                                serverSetting.settings.syncLoggingCullTrigger
                            ) {
                              return true;
                            }
                            openSnackbar({
                              open: true,
                              message:
                                "Value must be at least 40 and less than Cull Trigger amount",
                              variant: "alert",
                              alert: {
                                color: "error"
                              },
                              close: false
                            });
                            return false;
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </>
                )}
              </Grid>
            </center>
          </Table>
        )}
      </TableContainer>
    </Grid>
  );
}

export default ServerSettings;

function isKeyNameValid(name) {
  if (!name) return false;

  return KEY_NAME_REGEX.test(name);
}

function isKeyNameDuplicate(keys, name) {
  return keys.map(key => key.name).includes(name);
}

function getKeyNameHelperText(keys, name) {
  if (!isKeyNameValid(name)) {
    return "Invalid name";
  }

  if (isKeyNameDuplicate(keys, name)) {
    return "Name already in use";
  }

  return "";
}
